/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useState, useEffect } from 'react';
import { UploadIcon } from '@heroicons/react/solid';
import { Order } from '@Types/cart/Order';
import { fetchApiHub } from 'frontastic/lib/fetch-api-hub';
import UploadsDocumentsModal from '@Bic/components/commercetools-ui/business-unit/admin/panels/orders/modals/uploads-modal';

const UploadButton: React.FC<{order: Order}> = ({order}) => {
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [isUploadsModalOpen, setIsUploadsModalOpen] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        fetchApiHub(`/action/business-unit/getByKey?key=${order.businessUnit}`, {method: 'GET'})
        .then((result) => {
            /* TODO ADD Logic to display upload action only for sales rep*/
            setIsVisible(true);
        })
    });

    const handleOpenUploadsModel= (order) => {
        setSelectedOrder(order);
        setIsUploadsModalOpen(true);
    }

    const handleCloseUploadsModel= () => {
        setSelectedOrder(null);
        setIsUploadsModalOpen(false);
    }

    return (
        <div>
            {isVisible && (<button><UploadIcon className="h-4 w-4" onClick={() => handleOpenUploadsModel(order)}/></button>)}
            {isVisible && isUploadsModalOpen && (
                <UploadsDocumentsModal onClose={handleCloseUploadsModel} open={isUploadsModalOpen} order={selectedOrder} />
            )}
        </div>
    )
};

export default UploadButton;
